import b from 'b_';
import { Link, Text } from 'platform-components';
import React from 'react';

interface Props {
    currentStackProblemsCountInCurrentLesson: number;
    onRemoveFromLesson: (e: React.MouseEvent<HTMLElement>) => void;
    problemsCount: number;
}

const ThemePageStackBottomElementsAfterAddition = React.memo((props: Props) => {
    const { currentStackProblemsCountInCurrentLesson, onRemoveFromLesson, problemsCount } = props;
    const remainingProblemsCount = problemsCount - currentStackProblemsCountInCurrentLesson;
    const isVariantsCountBtnVisible = problemsCount > 1 && remainingProblemsCount > 0;

    return (
        <div className="theme-page__stack-controls">
            <Link mix="theme-page__remove-link" onClick={onRemoveFromLesson} theme={Link.THEME.STEALTHY}>
                <Text id="library.item.removeFromLesson" weight={Text.WEIGHT.M} />
            </Link>
            {isVariantsCountBtnVisible && (
                <div className={b('theme-page', 'variants-count', { type: 'remaining' })}>
                    <Text
                        id="library.item.remained"
                        size={Text.SIZE.S}
                        values={{ count: remainingProblemsCount }}
                        weight={Text.WEIGHT.M}
                    />
                </div>
            )}
        </div>
    );
});

export default ThemePageStackBottomElementsAfterAddition;
